import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card, Badge, Button, Link } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';
import { DataManager } from '../../../core/data-manager';
import { ResourceManager } from '../../../core/resource-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as IconPub } from '../../../assets/icon/pubblicazioni.svg';
import { ReactComponent as IconCorsi } from '../../../assets/icon/corsi.svg';
import { ReactComponent as IconEventi } from '../../../assets/icon/eventi.svg';
import { ReactComponent as IconConvegni } from '../../../assets/icon/convegni.svg';


import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, FreeMode, Scrollbar, Navigation } from "swiper/modules";

import 'swiper/css';
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/scrollbar";


export default function HomeMenu() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const [data, setData] = useState(null);


    useEffect(() => {
    }, []);


    return (
        <Container fluid={'md'} className='my-5' >
            <Row className='align-items-end'>
                <Col md={6} xs={12} className='mb-3' onClick={() => navigate('/pubblicazioni')} role='button'>
                    <Card className='p-3' style={{ backgroundColor: 'var(--primary-color)', border: 'none', borderRadius: '30px' }}>
                        <Card.Body>
                            <Row>
                                <Col sm={2} className='m-auto'>
                                    <IconPub fill='white' height={50}></IconPub>
                                </Col>
                                <Col sm={10}>
                                    <Row>
                                        <Col className='text-white'>
                                            <h4 className='mb-0'><b>Pubblicazioni</b></h4>
                                            <p className='mb-0'>Arricchisci le tue competenze tecniche e trasversali</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='text-white text-end'>
                                            <FontAwesomeIcon icon='arrow-right' size='xl'></FontAwesomeIcon>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6} xs={12} className='mb-3' onClick={() => navigate('/corsi')} role='button'>
                    <Card className='p-3' style={{ backgroundColor: 'var(--primary-color)', border: 'none', borderRadius: '30px' }}>
                        <Card.Body>
                            <Row>
                                <Col sm={2} className='m-auto'>
                                    <IconCorsi fill='white' height={50}></IconCorsi>
                                </Col>
                                <Col sm={10}>
                                    <Row>
                                        <Col className='text-white'>
                                            <h4 className='mb-0'><b>Corsi</b></h4>
                                            <p className='mb-0 text-white'>Migliora la tua preparazione lezione dopo lezione</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='text-white text-end'>
                                            <FontAwesomeIcon icon='arrow-right' size='xl'></FontAwesomeIcon>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6} xs={12} className='mb-3' onClick={() => navigate('/eventi')} role='button'>
                    <Card className='p-3' style={{ backgroundColor: 'var(--primary-color)', border: 'none', borderRadius: '30px' }}>
                        <Card.Body>
                            <Row>
                                <Col sm={2} className='m-auto'>
                                    <IconEventi fill='white' height={50}></IconEventi>
                                </Col>
                                <Col sm={10}>
                                    <Row>
                                        <Col className='text-white'>
                                            <h4 className='mb-0'><b>Seminari</b></h4>
                                            <p className='mb-0 text-white'>Resta aggiornato sugli appuntamenti in calendario</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='text-white text-end'>
                                            <FontAwesomeIcon icon='arrow-right' size='xl'></FontAwesomeIcon>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6} xs={12} className='mb-3' onClick={() => navigate('/eventi')} role='button'>
                    <Card className='p-3' style={{ backgroundColor: 'var(--primary-color)', border: 'none', borderRadius: '30px' }}>
                        <Card.Body>
                            <Row>
                                <Col sm={2} className='m-auto'>
                                    <IconConvegni fill='white' height={80}></IconConvegni>
                                </Col>
                                <Col sm={10}>
                                    <Row>
                                        <Col className='text-white'>
                                            <h4 className='mb-0'><b>Convegni</b></h4>
                                            <p className='mb-0 text-white'>La voce ai rappresentanti di categoria</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='text-white text-end'>
                                            <FontAwesomeIcon icon='arrow-right' size='xl'></FontAwesomeIcon>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>



        </Container>
    );

};